import { useAuthStore } from '../stores/auth-store';

/**
 * useCapability(code) → boolean.
 *
 * Consulta o `capabilities[]` do store. Capabilities são populadas pelo
 * `RequireAuth` via GET /v1/auth/me logo após login. Granularidade
 * tier-based (tier do tenant) + additionalCapabilities do User.
 */
export function useCapability(code: string): boolean {
  return useAuthStore((s) => s.capabilities.includes(code));
}

export function useCapabilities(): string[] {
  return useAuthStore((s) => s.capabilities);
}
